import * as Yup from 'yup';
import {ApplicationCategory, ApplicationStatus, ApplicationType, BusinessDomain} from '../types';

// FNP-79: when `provisionAutomatically` is on, the create kicks off the
// FNP-60 programmatic-provisioning state machine. The backend validates the
// name format (^[a-z][a-z0-9-]*$) and uniqueness in that flow; the form
// mirrors the format check for instant feedback.
const PROGRAMMATIC_NAME_REGEX = /^[a-z][a-z0-9-]*$/;

// FNP-287: subdomain shares the name's hostname-label charset. Same regex
// works because the field is also a single hostname label (no dots).
const SUBDOMAIN_REGEX = /^[a-z][a-z0-9-]*$/;

export const RecordSchema = Yup.object()
                               .shape({
                                          provisionAutomatically: Yup.boolean(),

                                          name: Yup.string()
                                                   .required('Required')
                                                   .when('provisionAutomatically', {
                                                       is: true,
                                                       then: (schema) => schema.matches(
                                                           PROGRAMMATIC_NAME_REGEX,
                                                           'Must be lowercase, start with a letter, and contain only letters, digits, and hyphens',
                                                       ),
                                                   }),

                                          // FNP-279: applicationCategory must
                                          // be set so the list table doesn't
                                          // render "Invalid Category" badges.
                                          applicationCategory: Yup.string()
                                                                  .oneOf(Object.values(ApplicationCategory))
                                                                  .required('Please select a category'),

                                          applicationStatus: Yup.string()
                                                                .oneOf(Object.values(ApplicationStatus))
                                                                .required('Please select a status'),

                                          businessDomain: Yup.string()
                                                             .when('provisionAutomatically', {
                                                                 is: true,
                                                                 then: (schema) =>
                                                                     schema.oneOf(Object.values(BusinessDomain))
                                                                           .required('Please select a business domain'),
                                                             }),

                                          applicationType: Yup.string()
                                                              .when('provisionAutomatically', {
                                                                  is: true,
                                                                  then: (schema) =>
                                                                      schema.oneOf(Object.values(ApplicationType))
                                                                            .required('Please select an application type'),
                                                              }),

                                          // FNP-287: optional subdomain (a
                                          // single hostname label). Empty
                                          // means apex deployment under the
                                          // parent domain. Validated only
                                          // when provisionAutomatically is
                                          // on; the backend mirrors the
                                          // same shape.
                                          subdomain: Yup.string()
                                                        .when('provisionAutomatically', {
                                                            is: true,
                                                            then: (schema) =>
                                                                schema.nullable()
                                                                      .notRequired()
                                                                      .test(
                                                                          'subdomain-format',
                                                                          'Must be a single hostname label: lowercase, start with a letter, only letters/digits/hyphens (no dots).',
                                                                          (value) => !value || SUBDOMAIN_REGEX.test(value),
                                                                      ),
                                                        }),
                                      });
